import { h } from 'vue'
import { RouterView } from 'vue-router'
export default [
  {
    path: '/:lang/news/',
    name: 'knowledge',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.KnowledgeCenter.name',
      weight: 99999,
      isHide: true,
      pageCode: 'ERA.UC.NEWS.LOGISTIVS',
    },
    redirect: {
      name: 'logisticsNews',
    },
    children: [
      {
        path: '/:lang/news/',
        name: 'logisticsNews',
        meta: {
          // name: 'News',
          name: 'home.header.KnowledgeCenter.News',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS',
          type: 'logisticsNews',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },
      {
        path: '/:lang/news/:id/',
        name: 'logisticsNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.list',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS.DETAIL',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },

      // 货运知识 列表页
      {
        path: '/:lang/news-knowledge/',
        name: 'knowledgeNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightKnowledge',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.KNOWLEDGE',
          type: 'knowledge',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },

      {
        path: '/:lang/news-knowledge/:id/',
        name: 'knowledgeNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightKnowledge.Tag.list',
          pageCode: 'ERA.UC.NEWS.KNOW.DETAIL',
          type: 'knowledge',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },

      {
        path: '/:lang/news-knowledge-:tag/',
        name: 'tagKnowledgeNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightKnowledge.Tag.Page',
          pageCode: 'ERA.UC.NEWS.KNOWLEDGE.TAG',
          type: 'knowledge',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 新增 货运区域 (Regions) 相关路由
      {
        path: '/:lang/news-regions/',
        name: 'regionsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightArea',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.REGIONS',
          type: 'knowledge_area',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },
      {
        path: '/:lang/news-regions/:id/',
        name: 'regionsNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightArea.Tag.list',
          pageCode: 'ERA.UC.NEWS.REGIONS.DETAIL',
          type: 'knowledge_area',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },
      {
        path: '/:lang/news-regions-:tag/',
        name: 'tagRegionsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightArea.Tag.Page',
          pageCode: 'ERA.UC.NEWS.REGIONS.TAG',
          type: 'knowledge_area',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },

      // 新增 货运经验 (Experience) 相关路由
      {
        path: '/:lang/news-experience/',
        name: 'experienceNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightExperience',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.EXPERIENCE',
          type: 'knowledge_experience',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },
      {
        path: '/:lang/news-experience/:id/',
        name: 'experienceNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightExperience.Tag.list',
          pageCode: 'ERA.UC.NEWS.EXPERIENCE.DETAIL',
          type: 'knowledge_experience',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },
      {
        path: '/:lang/news-experience-:tag/',
        name: 'tagExperienceNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightExperience.Tag.Page',
          pageCode: 'ERA.UC.NEWS.EXPERIENCE.TAG',
          type: 'knowledge_experience',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },

      //新增 货运解决方案 (Solutions) 相关路由
      {
        path: '/:lang/news-solutions/',
        name: 'solutionsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightSolutions',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.SOLUTIONS',
          type: 'knowledge_solutions',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },
      {
        path: '/:lang/news-solutions/:id/',
        name: 'solutionsNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightSolutions.Tag.list',
          pageCode: 'ERA.UC.NEWS.SOLUTIONS.DETAIL',
          type: 'knowledge_solutions',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },
      {
        path: '/:lang/news-solutions-:tag/',
        name: 'tagSolutionsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightSolutions.Tag.Page',
          pageCode: 'ERA.UC.NEWS.SOLUTIONS.TAG',
          type: 'knowledge_solutions',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },

      //新增 货运政策 (Policy) 相关路由
      {
        path: '/:lang/news-policy/',
        name: 'policyNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightPolicy',
          icon: 'NavKnowledgeNews',
          pageCode: 'ERA.UC.NEWS.POLICY',
          type: 'knowledge_policy',
          show: true,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
        children: [],
      },
      {
        path: '/:lang/news-policy/:id/',
        name: 'policyNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightPolicy.Tag.list',
          pageCode: 'ERA.UC.NEWS.POLICY.DETAIL',
          type: 'knowledge_policy',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },
      {
        path: '/:lang/news-policy-:tag/',
        name: 'tagPolicyNews',
        meta: {
          name: 'home.header.KnowledgeCenter.FreightPolicy.Tag.Page',
          pageCode: 'ERA.UC.NEWS.POLICY.TAG',
          type: 'knowledge_policy',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 会员新闻 列表页
      {
        path: '/:lang/jctransnews/',
        name: 'jctransNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News',
          pageCode: 'ERA.UC.NEWS.JCTRANS',
          type: 'jctransNews',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 会员新闻 详情页
      {
        path: '/:lang/jctransnews/:id/',
        name: 'JctransNewsDetail',
        meta: {
          name: 'home.header.KnowledgeCenter.News.detail',
          pageCode: 'ERA.UC.NEWS.JCTRANS.DETAIL',
        },
        component: () => import('@/pages/knowledge/News/detail.vue'),
      },

      // 会员新闻 标签列表页
      {
        path: '/:lang/jctransnews-:tag/',
        name: 'tagJctransNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.Page',
          pageCode: 'ERA.UC.NEWS.JCTRANS',
          type: 'jctransNews',
          show: false,
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      {
        path: '/:lang/news-:tag/',
        name: 'tagLogisticsNews',
        meta: {
          name: 'home.header.KnowledgeCenter.News.Tag.Page',
          pageCode: 'ERA.UC.NEWS.LOGISTIVS',
        },
        component: () => import('@/pages/knowledge/News/index.vue'),
      },
      // 会员新闻 标签详情页
      // {
      //   path: '/:lang/jctransnews/:tag/:page',
      //   name: 'tagPageJctransNews',
      //   meta: {
      //     name: 'home.header.KnowledgeCenter.News.Tag.PAGE',
      //     pageCode: 'ERA.UC.NEWS.JCTRANS.TAG.DETAIL',
      //     type: 'jctransNews',
      //     show: false,
      //   },
      //   component: () => import('@/pages/knowledge/News/index.vue'),
      // },
    ],
  },
  {
    path: '/:lang/resources/',
    name: 'Resources',
    component: () => import('~/pages/resources/index.vue'),
    meta: {
      name: 'Resources',
      pageCode: 'ERA.UC.RESOURCES',
    },
  },
  // 统一Search
  {
    path: '/:lang/blog/Search',
    name: 'BlogSearch',
    component: () => import('~/pages/resources/blogList.vue'),
    meta: {
      name: 'BlogSearch',
      pageCode: 'ERA.UC.BLOG.SEARCH',
    },
  },
  {
    path: '/:lang/blog/',
    name: 'Blog',
    component: () => import('~/pages/resources/blogTag.vue'),
    meta: {
      name: 'Blog',
      pageCode: 'ERA.UC.BLOG',
    },
  },
  {
    path: '/:lang/blog-:uid/',
    name: 'BlogList',
    component: () => import('~/pages/resources/blogList.vue'),
    meta: {
      name: 'BlogList',
      pageCode: 'ERA.UC.BLOG.TAG',
    },
  },
  {
    path: '/:lang/blog/:id/',
    name: 'BlogDetail',
    component: () => import('~/pages/resources/blogDetail.vue'),
    meta: {
      name: 'BlogDetail',
      pageCode: 'ERA.UC.BLOG.DETAIL',
    },
  },

  {
    path: '/:lang/successstory/',
    name: 'knowledgeSuccessStory',
    meta: {
      // name: 'Success Story',
      name: 'home.header.KnowledgeCenter.SuccessStory',
      icon: 'NavKnowledgeSuccess',
      pageCode: 'ERA.UC.SUCCESS',
      show: true,
    },
    component: () => import('~/pages/knowledge/SuccessStory/index.vue'),
  },
  {
    path: '/:lang/successstory/:district-:business/:searchKeyword?',
    name: 'knowledgeSuccessStoryPage',
    meta: {
      // name: 'Success Story',
      name: 'home.header.KnowledgeCenter.SuccessStory.Page',
      icon: 'NavKnowledgeSuccess',
      pageCode: 'ERA.UC.SUCCESS',
      show: true,
    },
    component: () => import('~/pages/knowledge/SuccessStory/index.vue'),
  },
  {
    path: '/:lang/successstory/detail/:id',
    name: 'knowledgeSuccessStoryDetail',
    meta: {
      pageCode: 'ERA.UC.SUCCESS.DETAIL',
    },
    component: () => import('~/pages/knowledge/SuccessStory/detail.vue'),
  },
]
